import { ApiError } from '../../services/api';

/** Older API hosts may not expose repeating-section child routes yet. */
export function isRepeatingCollectionRouteNotFound(error: unknown): boolean {
  return error instanceof ApiError && error.status === 404;
}
